import {useEffect, useState} from 'react';
import {Ticket} from '../types';
import {useWorkspace} from '../workspace/WorkspaceContext';
import {toast} from '../components/ui/sonner';

export function useTicketFeedback(ticket: Ticket) {
  const {update} = useWorkspace();
  const savedNote = ticket.feedback_note;
  const [noteOpen, setNoteOpen] = useState(false);
  const [note, setNote] = useState(savedNote);
  useEffect(() => { setNote(savedNote); }, [savedNote, setNote]);

  async function rate(rating: 'up' | 'down') {
    try {
      await update(ticket.id, {feedback: rating});
      if (rating === 'down') setNoteOpen(true);
      toast.success('Feedback recorded');
    } catch (error: any) { toast.error(error.message); }
  }

  async function saveNote() {
    try {
      await update(ticket.id, {feedback: 'down', feedback_note: note});
      setNoteOpen(false);
      toast.success('Feedback saved');
    } catch (error: any) { toast.error(error.message); }
  }

  return {noteOpen, note, setNote, rate, saveNote};
}

export type TicketFeedbackController = ReturnType<typeof useTicketFeedback>;